import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";


// Import router from next
import { useNavigate } from "react-router-dom";

const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjI1ODE1MjAxLCJqdGkiOiI5ZjBlZTlhYy1lM2ZhLTQ1MjEtOWJjYy1mNDUxYjQ4MWQwN2YiLCJ1c2VyX3V1aWQiOiJGRERCUzVWTEhYNUJVV0JRIn0._pUHaYDAX5DhxDoGj4sV17CVRqv91p5rh3P53dleKdI'; 

function Calendly({onSchedule, calendlyURL}) {

	const [userEmail, setUserEmail] = useState('');
	const [url, setUrl] = useState('');

	useEffect(() => {
		console.log(calendlyURL);
		setUrl(calendlyURL);
	},[url,calendlyURL]);

	useEffect(async () => {
		window.addEventListener(
			'submit',
			 (e) => {
				if (isCalendlyEvent(e)) {
					if(e.data.payload.event){
                        onSchedule(e.data.payload)
					}
				}
			}
		);

		var session_token = JSON.parse(localStorage.getItem("supabase.auth.token")) || '';
		setUserEmail(session_token ? session_token.currentSession.user.email : '');
		
	}, []);

    function isCalendlyEvent(e) {
		return e.data.event &&
			e.data.event.indexOf('calendly') === 0;
	};


	return (
            <div className="h-full">
				{
					url &&
					<InlineWidget url={url} 
					styles={{height: "100vh"}}
					/>
				}
            </div>
)
};

export default Calendly;